<div class="container">
    <div class="wrapper">
        <h1 class="pageTitle">{{pageTitle}}</h1>
        <app-notifications [notification]="'locations_page_notification_banner_parent'"></app-notifications>   
        <hr>

        <div class="row">
            <div class="mr-4" *ngFor="let location of locations">
                <div class="card locations-list"
                    (click)="updateMapView(location.address.lat, location.address.long); selectLocation(location)"
                    [ngClass]="{'selected-location-list': selectedLocation?.id === location?.id}">
                    <div class="location-item" [ngClass]="{'selected-location': selectedLocation?.id === location?.id}"
                        tabindex="0" role="button">
                        <div class="card-location-header">
                            <span class="material-icons">
                                location_on
                            </span>
                            <h5>{{location.name}}</h5>
                        </div>
                        <em>{{location.description}}</em>
                        <p class="mt-2" *ngIf="location?.address">
                            <span *ngIf="location?.address.address1">{{location.address.address1}}, <br /></span>
                            <span *ngIf="location?.address.address2">{{location.address.address2}}, <br /></span>
                            <span *ngIf="location?.address.address3">{{location.address.address3}}, <br /></span>
                            <span *ngIf="location?.address.address4">{{location.address.address4}}, <br /></span>
                            <span *ngIf="location?.address.address5">{{location.address.address5}}, <br /></span>
                            <span *ngIf="location?.address.postcode">{{location.address.postcode}} <br /></span>
                        </p>

                        <p class="phone"> <span *ngIf="location?.address.phone"><span class="material-icons"
                                    style="font-size: small !important;">
                                    phone
                                </span> {{location.address.phone}} <br />
                            </span>
                        </p>
                    </div>
                </div>
            </div>

            <div class="mt-4 col-sm-6" *ngIf="mapsRequired">
                <app-leaflet-map *ngIf="locations"></app-leaflet-map>
            </div>
        </div>

        <!-- <div class="row mt-4" *ngIf="!member">
            <div class="col-6">
                <button class="btn btn-primary" (click)="routerGoBack()" tabindex="0" role="button"
                    aria-label="Go back to services page">{{'COMMON.BACK' | translate}}</button>
            </div>
        </div> -->

    </div>
</div>